import * as net from 'util/Net';

const MetadataDAO = {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  bulkUpdateTagSchema(fileIds: Array<string>, tagSchemaId: string | null, deleteOldSchemaTags: boolean) {
    return net.postJSON({
      url: '/1/api/files/bulk-set-tag-schema',
      data: {
        fileIds,
        tagSchemaId,
        deleteOldSchemaTags,
      },
    });
  },
};

export default MetadataDAO;
